const analytics_strings = {
  analytics_events: {
    loginSuccess: "Login Success",
    loginFailed: "Login Failed",
    loginException: "Login Exception",
    registerSucces: "Registration Success",
    registerFailed: "Registration Failed",
    registerException: "Registration Exception",
    forgotButton: "Forgot",
    resetPasswordButton: "Reset Password",
    logoutButton: "Logout",
    submitButton: "Assessment Submit",
    feedbackButton: "Assessment Feedback",
    assessmentLogoutButton: "Assessment Logout",
    dashboard_skill_needHelp: "Dashboard Skill Need Help",
    reccomendation_needHelp: "Recommendation Need Help",
    programHub_needHelp: "ProgramHub Need Help",
    course_viewed: "Course View Clicked",
    lab_session: "LabSession_Viewed",
  },
  analytics_path: {
    resetPasswordPage: "/reset-password",
    assessmentQuestionPage: "/assessment/question",
    assessmentFeedBackPage: "/assessment/feedback",
  },
};
export default analytics_strings;
